const ContentRow: React.FC = ({ children }) => <div className="content-row">{children}</div>;

export default ContentRow;
